import { useMaybeProductBase, ProductBase } from "@made-people/grease-product";
import { useGeneralSettings } from "./use-general-settings";

const inferProductTypeFromProduct = (
  productBase: ProductBase | undefined,
): string | undefined => {
  if (!productBase) return undefined;

  const productTypeAttr = productBase.attributes.find(
    (attr) => attr.attributeKey === "product_type",
  );
  if (productTypeAttr?.value && typeof productTypeAttr.value === "string") {
    return productTypeAttr.value;
  }

  const categoryName = productBase.categories[0]?.name;
  if (categoryName) {
    const normalizedCategory = categoryName.toLowerCase();
    if (
      normalizedCategory.includes("bra") ||
      normalizedCategory.includes("bh")
    ) {
      return "bra";
    }
  }

  const slug = productBase.slug.toLowerCase();
  if (slug.includes("bra") || slug.includes("bh")) {
    return "bra";
  }

  return undefined;
};

const getProductSku = (
  productBase: ProductBase | undefined,
): string | undefined => {
  if (!productBase) return undefined;

  const skuAttr = productBase.attributes.find(
    (attr) => attr.attributeKey === "product_parent_id",
  );
  if (skuAttr?.value && typeof skuAttr.value === "string") {
    return skuAttr.value;
  }
  return undefined;
};

interface HundredWashesResult {
  show: boolean;
}

export const useHundredWashes = (): HundredWashesResult => {
  const productBase = useMaybeProductBase();
  const generalSettings = useGeneralSettings();

  const productType = inferProductTypeFromProduct(productBase);
  const isBra = productType === "bra";

  const productSku = getProductSku(productBase);
  const activeSkus =
    generalSettings?.washingsWarrantyActiveProductSkus?.split(",") || [];
  const skuEligible = productSku ? activeSkus.includes(productSku) : false;

  const show = isBra || skuEligible;

  return { show };
};
